export default 'REDUX_STORE_SYMBOL';